import React from 'react';
import { Music2, Heart, Mail, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#0a0a0a] border-t border-[#D4AF37]/20 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand & Address */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-6 cursor-pointer" onClick={scrollToTop}>
              <img 
                src="https://customer-assets.emergentagent.com/job_exact-replica-167/artifacts/8zqnwov9_1AC2C9EE-62B2-429B-AE9A-CFA74123D7DA%20%281%29.jpg"
                alt="40 Songs and a Mic"
                className="h-12 w-auto"
              />
              <div>
                <div className="text-white font-bold text-xl leading-tight" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  40 SONGS
                </div>
                <div className="text-[#D4AF37] text-xs font-semibold leading-tight" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  & A MIC
                </div>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Transforming lives through the power of gospel and hip-hop music combined with trauma-informed healing programs.
            </p>
            
            {/* Business Address */}
            <div className="flex items-start space-x-3 mb-4">
              <MapPin className="w-5 h-5 text-[#D4AF37] mt-1 flex-shrink-0" />
              <div className="text-gray-400 text-sm">
                <p className="font-bold text-white mb-1">40 Songs and a Mic</p>
                <p>4539 N 22ND ST #6535</p>
                <p>PHOENIX, AZ 85016, USA</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              QUICK LINKS
            </h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => document.getElementById('workbooks')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                  Workbooks
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('merch-store')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                  Merchandise
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('about-media')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('podcast')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                  Podcast Impact
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('music')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                  Music
                </button>
              </li>
            </ul>
          </div>

          {/* 501(c)(3) Donation Information */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              SUPPORT OUR MISSION
            </h4>
            <div className="bg-[#1a1a1a] border border-[#D4AF37]/20 rounded-lg p-4 mb-4">
              <div className="flex items-center space-x-2 mb-3">
                <Heart className="w-5 h-5 text-[#D4AF37]" />
                <span className="text-[#D4AF37] font-bold text-sm">501(c)(3) TAX-DEDUCTIBLE</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                We are grateful for our partners at <span className="text-white font-semibold">Gardens of Hope (501c)(3)</span>, who receive donations on behalf of our Sponsor a Transformation initiative.
              </p>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                If you would like to support this work and become a philanthropist helping transform lives through music and healing, please donate using the link below:
              </p>
              <a 
                href="https://thegardensofhope.org/donate-to-the-gardens-of-hope-donorbox/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0a0a0a] font-bold px-4 py-2 rounded-lg hover:from-[#FFD700] hover:to-[#D4AF37] transition-all duration-300 text-sm"
              >
                <span>DONATE NOW</span>
                <ExternalLink className="w-4 h-4" />
              </a>
              <p className="text-gray-500 text-xs mt-3 italic">
                Important: Donations must be made payable to Gardens of Hope. This applies only to donations, not merchandise or workbook purchases.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#D4AF37]/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © 2026 40 Songs and a Mic. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-500 hover:text-[#D4AF37] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-[#D4AF37] text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#merch-store" className="text-gray-500 hover:text-[#D4AF37] text-sm transition-colors">
                Shop Merch
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
